/*
 * File: d:\projects\AutoFiFront\src\Content\AboutUs\Values\Values.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Tuesday April 18th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday April 18th 2023 9:49:42 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import React, { ReactNode } from 'react';
import styles from 'Content/AboutUs/Values/Values.module.css';
import translator from 'MultiLanguage/TranslationWrapper';

type ValuesProps = {
    text: string,
    icon: ReactNode
};

function Values(props: ValuesProps) {
    return (
        <React.Fragment>
            <div className={`${styles.box}`}>
                <div className={`${styles.boxIcon}`}>
                    {props.icon}
                </div>
                {translator.decode(`aboutUs.${props.text}`)}
            </div>
        </React.Fragment>
    );
}

export default Values;
